module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container section"
  }, [_c('div', {
    staticClass: "row heading"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editing),
      expression: "editing"
    }],
    staticClass: "col text-right"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-success",
    on: {
      "click": _vm.save
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v("  Save\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-danger",
    on: {
      "click": _vm.cancel
    }
  }, [_c('i', {
    staticClass: "fa fa-remove"
  }), _vm._v("  Cancel\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-4",
    on: {
      "click": function($event) {
        _vm.editFields('name')
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editing),
      expression: "!editing"
    }],
    staticClass: "col-form-label"
  }, [_vm._v("\n                " + _vm._s(_vm.carrierDetails.name) + "\n                "), (_vm.$canAccess(21, 23)) ? _c('i', {
    staticClass: "editable-icon float-right fa fa-pencil text-muted"
  }) : _vm._e()]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editing),
      expression: "editing"
    }]
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selected.name),
      expression: "selected.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm._s(_vm.selected.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.selected.name = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 editable col-form-label",
    on: {
      "click": function($event) {
        _vm.editFields('commsrate')
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editing),
      expression: "!editing"
    }]
  }, [_vm._v("\n                " + _vm._s(_vm.carrierDetails.commsrate) + "\n                "), (_vm.$canAccess(21, 23)) ? _c('i', {
    staticClass: "editable-icon float-right fa fa-pencil text-muted"
  }) : _vm._e()]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editing),
      expression: "editing"
    }]
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selected.commsrate),
      expression: "selected.commsrate"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm._s(_vm.selected.commsrate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.selected.commsrate = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 editable col-form-label",
    on: {
      "click": function($event) {
        _vm.editFields('spiffrate')
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editing),
      expression: "!editing"
    }]
  }, [_vm._v("\n                " + _vm._s(_vm.carrierDetails.spiffrate) + "\n                "), (_vm.$canAccess(21, 23)) ? _c('i', {
    staticClass: "editable-icon float-right fa fa-pencil text-muted"
  }) : _vm._e()]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editing),
      expression: "editing"
    }]
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selected.spiffrate),
      expression: "selected.spiffrate"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm._s(_vm.selected.spiffrate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.selected.spiffrate = $event.target.value
      }
    }
  })])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3"
  }, [_c('h2', [_vm._v("Carrier Information")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-2 col-form-label"
  }, [_c('label', [_vm._v("Name")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col col-form-label text-truncate"
  }, [_c('label', [_vm._v("Commissions Rate")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col col-form-label text-truncate"
  }, [_c('label', [_vm._v("Spiff Rate")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7067c45c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/carriers/CarrierInformation.vue
// module id = 401
// module chunks = 0